import { render } from "./RegPage.vue?vue&type=template&id=44e2ecf8&scoped=true"
import script from "./RegPage.vue?vue&type=script&lang=js"
export * from "./RegPage.vue?vue&type=script&lang=js"

import "./RegPage.vue?vue&type=style&index=0&id=44e2ecf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e2ecf8"]])

export default __exports__